import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FieldDefinition } from "../../../../sections/medicinalProduct/message/fieldDefinition";
import { Injector } from "@angular/core";
import { Art57NodeUtils } from "../../Node/Art57Node/Art57NodeUtils";

export class AttachmentEntity extends FormlyView {

    constructor(injector: Injector, jsonData: any) {
        const fieldDefinition: FieldDefinition = new FieldDefinition(injector);
        let model = {};
        Art57NodeUtils.generateFormlyModel(fieldDefinition.attachmentFields,jsonData,model);    
        super( new FormGroup({}), 
            [...fieldDefinition.attachmentFields], model);
        // model                
    }

}